export default __webpack_public_path__ + "static/media/mute.d236ed34.svg";